import { FunctionComponent, memo } from "react";
import { IProps } from "./phrase-triggers-per-trigger-tooltip.types";
import { FormattedDate, NumericValue } from "@edgetier/client-components";
import "./phrase-triggers-per-trigger-tooltip.scss";

/**
 * Tooltip to display the total interactions count of a trigger in a date range
 * @param props.startDateTime       Start date from date range field
 * @param props.endDateTime         End date from date range field
 * @param props.totalTriggerInteractions    Number of total interactions from triggers
 * @param props.tooltipData         Tooltip details from recharts
 * @param props.phraseTriggerNames
 */
const PhraseTriggersPerTriggerTooltip: FunctionComponent<IProps> = ({
    startDateTime,
    endDateTime,
    totalTriggerInteractions,
    tooltipData,
    phraseTriggerNames,
}) => (
    <>
        {typeof tooltipData !== "undefined" && (
            <div className="phrase-triggers-per-trigger-tooltip">
                <div className="phrase-triggers-per-trigger-tooltip__title">
                    {phraseTriggerNames[tooltipData.payload.group]}
                </div>
                <div className="phrase-triggers-per-trigger-tooltip__date-range">
                    <FormattedDate dateTime={startDateTime} />
                    &ndash;
                    <FormattedDate dateTime={endDateTime} />
                </div>

                <div className="phrase-triggers-per-trigger-tooltip__data">
                    <div className="phrase-triggers-per-trigger-tooltip__datum">
                        <span className="phrase-triggers-per-trigger-tooltip__label">Interactions</span>
                        <span className="phrase-triggers-per-trigger-tooltip__value">
                            <NumericValue value={tooltipData.value ?? 0} />
                        </span>
                    </div>

                    <div className="phrase-triggers-per-trigger-tooltip__datum">
                        <span className="phrase-triggers-per-trigger-tooltip__label">Percentage of Total</span>
                        <span className="phrase-triggers-per-trigger-tooltip__value">
                            <NumericValue
                                value={tooltipData.value > 0 ? (tooltipData.value / totalTriggerInteractions) * 100 : 0}
                                unit={tooltipData.value > 0 ? "%" : undefined}
                                options={{
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }}
                            />
                        </span>
                    </div>
                </div>
            </div>
        )}
    </>
);

export default memo(PhraseTriggersPerTriggerTooltip);
